import React, { useState, useEffect } from "react";
import "./Ads.css";
import { getAds, deleteAds } from "../../api/adsApi";
import AddAds from "./AddAds";
import { CiTrash } from "react-icons/ci";
import ConfirmationModal from "../../components/MiniComponents/ConfirmationModal";
import toast from "react-hot-toast";

const column = [
  "S.No",
  "Ads Type",
  "Time Interval",
  "Ads Count",
  "Date",
  "Action",
];

export default function Ads() {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openAddModal, setOpenAddModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const fetchAds = async () => {
    try {
      setLoading(true);
      const res = await getAds();
      console.log("get ads resp:", res);
      setAds(res?.data || []);
    } catch (error) {
      console.error("error on get resp:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  const handleDeleteAds = async () => {
    try {
      const res = await deleteAds(deleteId);
      console.log("deleted ads resp:", res);

      toast.success("Ads deleted.");
      setDeleteId(null);
      fetchAds();
    } catch (error) {
      setDeleteId(null);
      console.error("error during delete ads:", error);
      toast.error("Failed to delete Ads.");
    }
  };

  return (
    <div className="main">
      <div className="contact-header">
        <h3>ADS</h3>
        <p>View and Manage Ads Config</p>
      </div>

      <div className="button">
        <button onClick={() => setOpenAddModal(true)}>+ Add ADS</button>
      </div>

      <div className="ads-table-wrapper">
        <table className="ads-table">
          <thead>
            <tr>
              {column.map((item) => (
                <th key={item}>{item}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading && ads.length === 0 ? (
              <tr>
                <td colSpan={column.length} className="no-data">
                  Loading...
                </td>
              </tr>
            ) : !loading && ads.length === 0 ? (
              <tr>
                <td colSpan={column.length} className="no-data">
                  No Ads Available
                </td>
              </tr>
            ) : (
              ads?.map((ad, index) => (
                <tr key={ad._id || index}>
                  <td>{index + 1}</td>
                  <td>{ad.adsType}</td>
                  <td>{ad.intervalSeconds} sec</td>
                  <td>{ad.adsCount}</td>
                  <td>{new Date(ad.createdAt).toLocaleDateString()}</td>
                  <td>
                    <CiTrash size={18} onClick={() => setDeleteId(ad._id)} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {openAddModal && (
        <AddAds
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          onSuccess={fetchAds}
        />
      )}
      {deleteId && (
        <ConfirmationModal
          title="Are yo sure want to delete this Ads."
          onCancel={() => setDeleteId(null)}
          onConfirm={handleDeleteAds}
        />
      )}
    </div>
  );
}
